import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddRoleState, addRoleFeatureKey } from './add-role.reducer';

const getAddRoleFeature = createFeatureSelector<AddRoleState>(addRoleFeatureKey);

export const getAddRoleCallState = createSelector(getAddRoleFeature, (state) => {
   return state.callState;
});
